import React from 'react';

import { useUserProfile } from '../../../../core/TTgraphql';
import { getPaymentMethodUsedForRentPayments } from '../../../../helpers/payments-helper';
import SegmentTrackingProvider from '../../../../providers/SegmentTrackingProvider';
import OnboardingProgress from '../../components/OnboardingProgress';

import ExistingPaymentMethodForRentPayments from './components/ExistingPaymentMethodForRentPayments';
import NoPaymentMethod from './components/NoPaymentMethod';

const mapper = {
  addDebit: {
    event: 'payment_method submit',
    location: 'Tenant Onboarding Payment Method Page - Add Debit Card',
  },
  addCredit: {
    event: 'payment_method submit',
    location: 'Tenant Onboarding Payment Method Page - Add Credit Card',
  },
  addBank: {
    event: 'payment_method submit',
    location: 'Tenant Onboarding Payment Method Page - Add Bank',
  },
  addManual: {
    event: 'payment_method submit',
    location: 'Tenant Onboarding Payment Method Page - Add Bank Manually',
  },
  goBack: {
    event: 'back clicked',
  },
  saveCard: {
    event: 'save_card clicked',
  },
  pageView: {
    event: 'page viewed',
    location: 'Tenant Onboarding Payment Method Page',
  },
  useExistingCard: {
    event: 'payment_method submit',
    location: 'Tenant Onboarding Payment Method Page - Use Existing PM',
  },
};

const PaymentMethod = () => {
  const { user } = useUserProfile();

  const paymentMethod = getPaymentMethodUsedForRentPayments(user);
  const paymentMethods = user?.payment_methods || [];

  return (
    <>
      <OnboardingProgress step="Rent Payments" progress={10} />

      <SegmentTrackingProvider mapper={mapper}>
        {paymentMethods.length > 0 ? (
          <ExistingPaymentMethodForRentPayments
            paymentMethod={paymentMethod?.id}
            paymentMethods={paymentMethods}
          />
        ) : (
          <NoPaymentMethod />
        )}
      </SegmentTrackingProvider>
    </>
  );
};
export default PaymentMethod;
